<template>
    <time>{{ time }}</time>
</template>

<script>
    import moment from 'moment';

    export default {
        props: {
            from: {
                type: String,
                default: null
            },
            shouldContinue: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                seconds: this.from? moment().unix() - moment(this.from).unix() : 0
            }
        },
        mounted() {
            this.tick();
        },
        methods: {
            tick() {
                setTimeout(() => {
                    if (this.shouldContinue) {
                        this.seconds++;
                    }
                    this.tick();
                }, 1000);
            }
        },
        computed: {
            time() {
                let hours = (Math.floor(this.seconds / 3600) + '').padStart(2, '0'),
                    minutes = (Math.floor((this.seconds % 3600) / 60) + '').padStart(2, '0'),
                    seconds = (this.seconds % 3600 % 60 + '').padStart(2, '0');

                return hours + ':' + minutes + ':' + seconds;
            }
        }
    }
</script>
